<div *ngIf="refundModalPageTwo" class="text-red fw-600 mb-3" style="font-size: 15px;">{{ "Select a Reason for Refund" | translate | async }}</div>
<div *ngIf="voidModalPageTwo" class="text-red fw-600 mb-3" style="font-size: 15px;">{{ "Select a Reason for Void" | translate | async }}</div>

<div class="reason_list mb-3">
  <ng-container *ngFor="let option of refundOptions; let i = index">
    <div class="form-check">
      <label class="form-check-label">
        <input
          class="red-chek form-check-input ms-1 me-3"
          type="radio"
          name="uniqueradio"
          value="{{ option }}"
          [(ngModel)]="refundReason"
          (ngModelChange)="cRefundModalPageTwo?changeCRefundReasonFunc($event):changeRefundReasonFunc($event)"
        />
        {{ option | translate | async}}
      </label>
    </div>
  </ng-container>
</div>

<div class="mb-3">
  <textarea
    rows="5"
    maxlength="200"
    [placeholder]="'Add any extra refund notes.' | translate | async"
    class="form-control text-area-theme"
    id="message-text"
    value=""
    [(ngModel)]="noteReason"
    (ngModelChange)="cRefundModalPageTwo?changeCRefundReasonNoteFunc($event):changeRefundReasonNoteFunc($event)"
  ></textarea>
  <div>{{ 200 - noteReason.length }}/200</div>
</div>
<!-- <div class="row">
  <div class="col-6 mb-3"></div>
  <div class="col-6 mb-3">
    <button
      class="w-100 btn w-100 f-18 fw-600 bg-gray text-white bg-red"
      (click)="handleRefund()"
    >
      REFUND - $13.23
    </button>
  </div>
</div> -->
